module.exports = __webpack_public_path__ + "static/media/american-football.207f21f3.svg";